import React from 'react';
import LegalPage from '../../components/PublicSite/LegalPage';
import fetchStaticPage from '../../components/PublicSite/fetchStaticPage';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';
import loadSiteCopy from '../../components/PublicSite/loadSiteCopy';

// StaticPage id 2 — dinamai "Rider" di dashboard, tapi isinya Terms and
// Conditions. Route yang sama dipakai /user; ini menampilkannya di chrome
// situs publik, karena footer menautkan /terms di setiap halaman.
async function action() {
  await loadSiteCopy();
  const result = await fetchStaticPage(2);

  return {
    // metaTitle di DB adalah "User" — nama internal dashboard, bukan judul
    // halaman. Judul situs ditetapkan di sini.
    title: 'Terms & Conditions — Bas Recovery',
    description: (result && result.metaDescription) || '',
    component: (
      <HeadLessLayout>
        <LegalPage result={result} current="/terms" titleKey="legal.terms.h1" />
      </HeadLessLayout>
    ),
  };
}

export default action;
